import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
// THE ORDER OF THIS IMPORT IS VERY IMPORTANT
import 'router'
// THE ORDER OF THIS IMPORT IS VERY IMPORTANT
import { reducer as global } from 'store/redux/global'
import { reducer as page } from 'store/redux/page'
import { reducer as auth } from 'store/redux/auth'
import { reducer as routerData } from 'store/redux/routerData'
import { reducer as ui } from 'store/redux/ui'
import { reducer as system } from 'store/redux/system'
import { reducer as phase } from 'store/redux/phase'
import { reducer as phaseInfo } from 'store/redux/phaseInfo'
import { reducer as mocks } from 'store/redux/mocks'
import { reducer as mc } from 'store/redux/mc'
import { reducer as superadmin } from 'store/redux/superadmin'

import rootSaga from 'store/sagas'
import configureStore from 'store/configureStore'

const rootReducer = combineReducers({
    form,
    auth,
    global,
    page,
    routerData,
    system,
    ui,
    phase,
    phaseInfo,
    mocks,
    mc,
    superadmin
})

const { store, persistor: Persistor } = configureStore(rootReducer, rootSaga)

export const persistor = Persistor

export default store



// WEBPACK FOOTER //
// src/store/index.js